import styled from 'styled-components';

export const GridFormContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => theme.spacing(20)};
`;

export const SideBySide = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => theme.spacing(20)};
`;

export const FormBody = styled.div`
  ${({ theme }) =>
    `
          margin: ${theme.spacing(25)} ${theme.spacing(40)} ${theme.spacing(30)};
        `};
`;
